export default class Social {
    constructor(name, url) {
        this.name = name;
        this.url = url;
    }
}
